

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AdminView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminAdmins } from "@/lib/query/core/invalidation";
import { queryKeys } from "@/lib/query/core/query-keys";

type UpdateAdminInput = {
  adminId: string;
  name?: string;
  email?: string;
  phone?: string;
  roles?: string[];
};

export function useUpdateAdminMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ adminId, ...body }: UpdateAdminInput) =>
      apiJsonClient<AdminView>(endpoints.admin.adminById(adminId), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }),
    onSuccess: async (_data, variables) => {
      await invalidateAdminAdmins(queryClient);
      await queryClient.invalidateQueries({
        queryKey: queryKeys.admin.adminById(variables.adminId),
        exact: true,
      });
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
